import { render, staticRenderFns } from "./Layout12.vue?vue&type=template&id=771d313e&scoped=true"
import script from "./Layout12.vue?vue&type=script&lang=js"
export * from "./Layout12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771d313e",
  null
  
)

export default component.exports